<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Team - {{ teamGroup.controls.nameControl.value }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="teamGroup">
            <mat-card-subtitle>General</mat-card-subtitle>
            <div class="img-preview-container square">
                <img [src]="teamGroup.controls.logoControl.value || placeholderTeamLogo">
            </div>
            <input type="file" accept="image/png, image/jpeg" #logoInput hidden (change)="uploadLogo($event)">
            <button class="upload-button" mat-raised-button *ngIf="logoUploadProgress == 0 && !teamGroup.controls.logoControl.value" (click)="logoInput.click()" color="accent"><mat-icon>upload</mat-icon>Upload</button>
            <button class="upload-button" mat-raised-button *ngIf="logoUploadProgress == 0 && teamGroup.controls.logoControl.value" (click)="logoInput.click()" color="accent"><mat-icon>upload</mat-icon>Replace</button>
            <button class="upload-button" mat-raised-button *ngIf="logoUploadProgress > 0" disabled><mat-progress-spinner mode="determinate" value="{{ logoUploadProgress }}"></mat-progress-spinner></button>
            <button class="delete-button-img" mat-raised-button *ngIf="teamGroup.controls.logoControl.value && !isProcessingLogoDelete" (click)="deleteLogo(false)" color="warn"><mat-icon>delete_outline</mat-icon>Delete</button>
            <button class="delete-button-img" mat-raised-button *ngIf="!teamGroup.controls.logoControl.value && !isProcessingLogoDelete" disabled><mat-icon>delete_outline</mat-icon>Delete</button>
            <button class="delete-button-img" mat-raised-button *ngIf="isProcessingLogoDelete" disabled><mat-spinner></mat-spinner></button>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Team Name</mat-label>
                <input matInput type="text" [formControl]="teamGroup.controls.nameControl" (input)="changeName()">
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Tricode</mat-label>
                <input matInput type="text" [formControl]="teamGroup.controls.tricodeControl" (input)="changeTircode()">
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Competition</mat-label>
                <mat-select [formControl]="teamGroup.controls.competitionControl" (selectionChange)="changeCompetition()">
                    <mat-select-trigger>
                        <ng-container *ngIf="getSelectedCompetition(teamGroup.controls.competitionControl.value) as competition">
                            <img class="select-field-logo" [src]="competition.logo || placeholderImage"> {{ competition.name }}
                        </ng-container>
                    </mat-select-trigger>
                    <ng-container *ngFor="let competition of competitions">
                        <mat-option [value]="competition.uid">
                            <img class="select-field-logo" [src]="competition.logo || placeholderImage"> {{ competition.name }}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                <mat-label>Notes</mat-label>
                <textarea matInput [formControl]="teamGroup.controls.notesControl" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="10" (input)="changeNotes()"></textarea>
            </mat-form-field>
            <mat-divider></mat-divider>
            <mat-card-subtitle>Staff</mat-card-subtitle>
            <table>
                <tr>
                    <td>Coach</td>
                    <td>
                        <img [src]="teamGroup.controls.coachpictureControl.value || placeholderPersonImage">
                    </td>
                    <td>
                        <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                            <mat-label>Coach</mat-label>
                            <input matInput type="text" [formControl]="teamGroup.controls.coachControl" (input)="changeCoach()">
                        </mat-form-field>
                    </td>
                    <td>
                        <input type="file" accept="image/png, image/jpeg" #coachPicInput hidden (change)="uploadCoachPic($event)">
                        <mat-icon matTooltip="Upload Picture" *ngIf="!teamGroup.controls.coachpictureControl.value && coachPicUploadProgress == 0" (click)="coachPicInput.click()">add_a_photo</mat-icon>
                        <mat-icon matTooltip="Replace Picture" *ngIf="teamGroup.controls.coachpictureControl.value && coachPicUploadProgress == 0" (click)="coachPicInput.click()">add_a_photo</mat-icon>
                        <mat-progress-spinner *ngIf="coachPicUploadProgress > 0" mode="determinate" value="{{ coachPicUploadProgress }}"></mat-progress-spinner>
                    </td>
                    <td>
                        <mat-icon matTooltip="Delete Picture" *ngIf="teamGroup.controls.coachpictureControl.value && !isDeleteCoachPic" (click)="deleteCoachPic(false)">delete_outline</mat-icon>
                        <mat-spinner *ngIf="isDeleteCoachPic"></mat-spinner>
                    </td>
                </tr>
                <tr>
                    <td>Asst. Coach</td>
                    <td><img [src]="teamGroup.controls.asscoachpictureControl.value || placeholderPersonImage"></td>
                    <td>
                        <mat-form-field appearance="fill" [hideRequiredMarker]="true">
                            <mat-label>Assistant coach</mat-label>
                            <input matInput type="text" [formControl]="teamGroup.controls.asscoachControl" (input)="changeAssCoach()">
                        </mat-form-field>
                    </td>
                    <td>
                        <input type="file" accept="image/png, image/jpeg" #asscoachPicInput hidden (change)="uploadAssCoachPic($event)">
                        <mat-icon matTooltip="Upload Picture" *ngIf="!teamGroup.controls.asscoachpictureControl.value && asscoachPicUploadProgress == 0" (click)="asscoachPicInput.click()">add_a_photo</mat-icon>
                        <mat-icon matTooltip="Replace Picture" *ngIf="teamGroup.controls.asscoachpictureControl.value && asscoachPicUploadProgress == 0" (click)="asscoachPicInput.click()">add_a_photo</mat-icon>
                        <mat-progress-spinner *ngIf="asscoachPicUploadProgress > 0" mode="determinate" value="{{ asscoachPicUploadProgress }}"></mat-progress-spinner>
                    </td>
                    <td>
                        <mat-icon matTooltip="Delete Picture" *ngIf="teamGroup.controls.asscoachpictureControl.value && !isDeleteAssCoachPic" (click)="deleteAssCoachPic(false)">delete_outline</mat-icon>
                        <mat-spinner *ngIf="isDeleteAssCoachPic"></mat-spinner>
                    </td>
                </tr>
            </table>
            <mat-divider></mat-divider>
            <mat-card-subtitle>Player</mat-card-subtitle>
            <table>
                <tr>
                    <th>Position</th>
                    <th></th>
                    <th class="add-player-line" colspan="3">
                        <button class="add-player-button" mat-raised-button *ngIf="isAddingPlayer" disabled><mat-spinner></mat-spinner></button>  
                        <button class="add-player-button" mat-raised-button *ngIf="!isAddingPlayer" color="accent" (click)="addPlayer()"><mat-icon>person_add</mat-icon>Add Player</button>
                    </th>         
                </tr>
                <tr *ngFor="let player of playerList">
                    <td *ngIf="player.position != 6">{{ player.position }}</td>
                    <td *ngIf="player.position == 6">Sub</td>
                    <td><img [src]="player.picture || placeholderPersonImage"></td>
                    <td><img class="country-flag" [src]="'https://assets.liumex.com/resources/esportsms/content/f/' + player.nationality + '.svg'">{{ player.name }}</td>
                    <td>
                        <mat-spinner *ngIf="player.uid == isEditPlayer"></mat-spinner>
                        <mat-icon matTooltip="Edit Player" *ngIf="player.uid != isEditPlayer" (click)="editPlayer(player)">edit</mat-icon>
                    </td>
                    <td>
                        <mat-spinner *ngIf="player.uid == isDeletePlayer"></mat-spinner>
                        <mat-icon matTooltip="Delete Player" *ngIf="player.uid != isDeletePlayer" (click)="deletePlayer(player)">delete_outline</mat-icon>
                    </td>
                </tr>
            </table>
            <mat-divider></mat-divider>
            <button class="duplicate-button" mat-raised-button (click)="duplicateTeam()" *ngIf="!isProcessingDuplication" color="primary"><mat-icon>file_copy</mat-icon>Duplicate</button>   
            <button class="duplicate-button" mat-raised-button *ngIf="isProcessingDuplication" disabled><mat-spinner></mat-spinner></button>
            <button class="delete-button" mat-raised-button (click)="deleteTeam()" *ngIf="!isProcessingDelete" color="warn"><mat-icon>delete_outline</mat-icon>Delete Team</button>
            <button class="delete-button" mat-raised-button *ngIf="isProcessingDelete" disabled><mat-spinner></mat-spinner></button>
        </form>
    </mat-card-content>
</mat-card>